module.exports = __webpack_public_path__ + "static/img/news.664ea11c.png";